"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense, useEffect, useState } from "react";
import { PhoneCall, Phone, Mail, FileText } from "lucide-react";
import { cn } from "@/lib/utils";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import dynamic from "next/dynamic";
const RequestCallbackForm = dynamic(() => import("@/components/forms/request-callback-form").then(mod => mod.RequestCallbackForm), {
  ssr: false
});
const EnquiryForm = dynamic(() => import("@/components/forms/enquiry-form").then(mod => mod.EnquiryForm), {
  ssr: false
});
export default function FooterActionBar() {
  const $ = _c(26);
  const [isVisible, setIsVisible] = useState(false);
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const footer = document.querySelector("footer");
      let isFooterVisible = false;
      const updateVisibility = () => {
        const scrolled = window.scrollY > 300;
        setIsVisible(scrolled && !isFooterVisible);
      };
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        isFooterVisible = entry.isIntersecting;
        updateVisibility();
      }, {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      });
      if (footer) {
        observer.observe(footer);
      }
      window.addEventListener("scroll", updateVisibility, {
        passive: true
      });
      updateVisibility();
      return () => {
        if (footer) {
          observer.unobserve(footer);
        }
        window.removeEventListener("scroll", updateVisibility);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = isVisible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-full opacity-0";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("bg-primary text-primary-foreground dark:bg-card fixed right-0 bottom-0 left-0 z-40 w-full shadow-[0_-8px_30px_rgb(0,0,0,0.15)] transition-all duration-500 ease-in-out", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsCallbackOpen(true);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-white/10 transition-transform duration-200 hover:scale-105 md:size-11"><PhoneCall className="size-4 md:size-5" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <button onClick={t4} className="flex flex-col items-center justify-center gap-1.5 py-2.5 text-center transition-colors duration-200 hover:bg-white/5 md:flex-row md:items-center md:justify-start md:gap-4 md:px-6 md:py-4 md:text-left">{t5}<div className="flex flex-col items-center md:items-start"><span className="text-[10px] font-bold tracking-tight md:text-sm"><span className="hidden sm:inline">Request a Callback</span><span className="sm:hidden">Callback</span></span><span className="hidden text-[10px] text-blue-100/75 md:block md:text-xs">Talk to a training advisor</span></div></button>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-white/10 transition-transform duration-200 hover:scale-105 md:size-11"><Phone className="size-4 md:size-5" /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <a href="tel:+19082937144" className="flex flex-col items-center justify-center gap-1.5 py-2.5 text-center transition-colors duration-200 hover:bg-white/5 md:flex-row md:items-center md:justify-start md:gap-4 md:px-6 md:py-4 md:text-left">{t7}<div className="flex flex-col items-center md:items-start"><span className="text-[10px] font-bold tracking-tight md:text-sm"><span className="hidden sm:inline">+1 (908) 293 7144</span><span className="sm:hidden">Call us</span></span><span className="hidden text-[10px] text-blue-100/75 md:block md:text-xs">Call us</span></div></a>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-white/10 transition-transform duration-200 hover:scale-105 md:size-11"><Mail className="size-4 md:size-5" /></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <a href="mailto:info@spoclearn.com" className="flex flex-col items-center justify-center gap-1.5 py-2.5 text-center transition-colors duration-200 hover:bg-white/5 md:flex-row md:items-center md:justify-start md:gap-4 md:px-6 md:py-4 md:text-left">{t9}<div className="flex flex-col items-center md:items-start"><span className="truncate text-[10px] font-bold tracking-tight sm:max-w-none md:text-sm"><span className="hidden sm:inline">info(at)spoclearn(dot)com</span><span className="sm:hidden">Mail us</span></span><span className="hidden text-[10px] text-blue-100/75 md:block md:text-xs">Mail us</span></div></a>;
    t11 = () => setIsEnquiryOpen(true);
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-black/15 transition-transform duration-200 hover:scale-105 md:size-11"><FileText className="size-4 text-white md:size-5" /></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="grid grid-cols-4 divide-x divide-white/10">{t6}{t8}{t10}<button onClick={t11} className="bg-secondary hover:bg-secondary/90 flex flex-col items-center justify-center gap-1.5 py-2.5 text-center transition-colors duration-200 md:flex-row md:items-center md:justify-start md:gap-4 md:px-6 md:py-4 md:text-left">{t12}<div className="flex flex-col items-center md:items-start"><span className="text-secondary-foreground text-[10px] font-bold tracking-tight md:text-sm"><span className="hidden sm:inline">Drop an Enquiry</span><span className="sm:hidden">Enquire</span></span><span className="text-secondary-foreground/80 hidden text-[10px] md:block md:text-xs">Get a custom proposal</span></div></button></div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t3) {
    t14 = <div id="footer-sticky-action-bar" className={t3}>{t13}</div>;
    $[14] = t3;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <DialogContent className="max-h-[90vh] overflow-y-auto p-0 sm:max-w-2xl"><Suspense><RequestCallbackForm onSuccess={() => setIsCallbackOpen(false)} /></Suspense></DialogContent>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== isCallbackOpen) {
    t16 = <Dialog open={isCallbackOpen} onOpenChange={setIsCallbackOpen}>{t15}</Dialog>;
    $[17] = isCallbackOpen;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <DialogContent className="max-h-[90vh] overflow-y-auto p-0 sm:max-w-2xl"><Suspense><EnquiryForm onSuccess={() => setIsEnquiryOpen(false)} isCourseVisible={true} title="Drop an Enquiry" description="Fill the details below" /></Suspense></DialogContent>;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== isEnquiryOpen) {
    t18 = <Dialog open={isEnquiryOpen} onOpenChange={setIsEnquiryOpen}>{t17}</Dialog>;
    $[20] = isEnquiryOpen;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== t14 || $[23] !== t16 || $[24] !== t18) {
    t19 = <>{t14}{t16}{t18}</>;
    $[22] = t14;
    $[23] = t16;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  return t19;
}